import { numberOfForecastDays } from '../constants';

export const getEntitlements = (state) => {
  const data = state.user.entitlements;
  if (data) {
    return data;
  }
  return null;
};

export const getIsPremiumEntitlement = state => state.user.entitlements.includes('bw_premium');

export const getNumberOfDaysForecast = (state) => {
  if (state.user.entitlements.includes('bw_premium')) {
    return numberOfForecastDays.PREMIUM;
  }
  return numberOfForecastDays.FREE;
};



// WEBPACK FOOTER //
// ./src/selectors/entitlements.js